import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ForceUpdateStateService } from '@app/shared/services/force-update-state.service';

export const forceUpdateGuard: CanActivateFn = () => {
  const state = inject(ForceUpdateStateService);
  const router = inject(Router);

  if (state.state().active) {
    return router.parseUrl('/force-update');
  }
  return true;
};
